module.exports = __webpack_public_path__ + "assets/wall-street.dd371044.svg";